import React, {Fragment, useEffect, useState} from 'react';
import moment from "moment";
import Color from "color";


const TemplateCUBEquipement = (props) => {


    useEffect(()=>{
    }, [])


    return (
        <div className="ue-section">
            <div className="text-left text-underline">
                <h3>ARTICLE 7 - Équipements</h3>
            </div>
            <p>L’état des équipements publics prévus ou existants est le suivant :</p>
            <br/>
            <table className={"ue-form-table-row"} style={{"width":"100%"}}>
                    <thead style={{'fontWeight':'bold', 'color':"#000000"}}>
                    <tr className={"ue-table-row-header"}>
                        <th className={"text-left"} >Catégorie</th>
                        <th>Desservi</th>
                        <th>Capacité</th>
                        <th>Gestionnaire</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr style={{"borderTop": "1px solid #ccc", "borderBottom": "1px solid #ccc",  "height":"40px"}}>
                        <td>Eau potable</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr style={{"borderBottom": "1px solid #ccc",  "height":"40px"}}>
                        <td>Electricité</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr style={{"borderBottom": "1px solid #ccc",  "height":"40px"}}>
                        <td>Assainissement</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr style={{"borderBottom": "1px solid #ccc",  "height":"40px"}}>
                        <td>Voirie</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    </tbody>
                </table>
                <br/>
        </div>
    );
};

export default TemplateCUBEquipement;
